// Tradução portuguesa

const pt = {
  "hotel.folio": "Fólios",
  "hotel.folio.registration_state": "Estado de registro",
  "hotel.folio.room": "Quarto",
  "hotel.folio.main_guest": "Hóspede principal",
  "hotel.folio.nights_quantity": "Noites",
  "hotel.folio.arrival_date": "Data de chegada",
  "hotel.folio.departure_date": "Data de saída",
  "hotel.folio.notes": "Observações",
  "hotel.folio.breakfast_included": "Café da manhã incluído",
  "hotel.folio.check_in": "Check-in",
  "hotel.folio.check_out": "Check-out",
  "hotel.folio.reverse_checkout": "Reverter check-out",
  "hotel.folio.confirm": "Confirmar",
  "hotel.folio.pending": "Pendente",
  "hotel.folio.booking": "Reserva",
  "hotel.folio.contact": "Contato",
  "hotel.folio.registration_card": "Ficha de registro",
  "hotel.folio.product": "Serviço",
  "hotel.folio.unit_price": "Preço unitário",
  "hotel.folio.channel": "Canal",
  "hotel.folio.group": "Grupo",
  "hotel.folio.total_amount": "Valor total",
  "hotel.folio.bed_breakfast": "Cama e café da manhã",
  "hotel.folio.no_breakfast": "Sem café da manhã",
  "hotel.folio.all_inclusive": "Tudo incluído",
  "hotel.folio.full_american": "Pensão completa",
  "hotel.folio.half_american": "Meia pensão",
  "hotel.folio.num_adults": "Número de adultos",
  "hotel.folio.num_children": "Número de crianças",
  "hotel.folio.number": "Número",
  "hotel.folio.pax": "PAX",
  "hotel.folio.charge.folio": "Fólio",
  "hotel.folio.charge.order": "Pedido",
  "hotel.folio.charge.kind": "Tipo",
  "hotel.folio.charge.invoice_line": "Fatura",
  "hotel.folio.charge.draft": "Rascunho",
  "hotel.folio.occupancy": "Ocupação",
  "hotel.folio.occupancy.occupancy_date": "Data",
  "hotel.folio.occupancy.unit_price": "Preço unitário",
  "hotel.folio.occupancy.unit_price_w_tax": "Preço unitário com imposto",
  "hotel.folio.occupancy.charge": "Cobrança",
  "hotel.folio.occupancy.state": "Estado",
  "hotel.folio.occupancy.draft": "Rascunho",
  "hotel.folio.occupancy.confirmed": "Confirmado",
  "hotel.folio.occupancy.invoiced": "Faturado",
  "hotel.folio.guest.city": "Cidade",
  "sale.line.unit_price_w_tax": "Preço + imposto",
};

export default pt;
